export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_08.0b020c2f.jpg";